import { useSelector } from 'react-redux';
import Cookies from 'js-cookie';
import { getCookie } from '@zorba-shared/client/Services/clientService';
import classNames from 'classnames';
import { COOKIE_NAME_MIMIC_TOKEN } from '../../../services/authService';
import { ZorbaButton } from '../../forms';
import { BUTTON_VARIANT_SECONDARY } from '../../forms/ZorbaButton/constants';
import DisableApp from './Components/DisableApp';

import './index.scss';

const Page = ({ className, wide, align, children }) => {
  const { userDetails } = useSelector(({ AuthReducer }) => AuthReducer);
  const mimicToken = getCookie(COOKIE_NAME_MIMIC_TOKEN);
  const handleRemoveCookie = () => {
    Cookies.remove(COOKIE_NAME_MIMIC_TOKEN, {
      path: '/',
      domain: '.getzorba.com',
    });
    window.opener = null;
    window.open('', '_self');
    window.close();
  };

  return (
    <div
      className={classNames(
        { [className]: className !== '' },
        { wide, [`align-${align}`]: !!align },
      )}
    >
      {mimicToken && (
        <div className="mimic-container">
          <div className="text-wrapper">
            {`Viewing as ${userDetails?.name} (${userDetails?.email})`}
          </div>
          <div className="button-wrapper">
            <ZorbaButton
              fullWidth={false}
              variant={BUTTON_VARIANT_SECONDARY}
              onClick={handleRemoveCookie}
            >
              Close session
            </ZorbaButton>
          </div>
        </div>
      )}
      <div className="page-inner">
        <div className="page-inner-content">{children}</div>
      </div>
      <DisableApp
        isVerified={userDetails?.defaultOrganization?.verification?.verified}
        isBanned={userDetails?.isBanned}
        isCompletedOnboarding={userDetails?.isCompletedOnboarding}
      />
    </div>
  );
};

export default Page;
